export default {
  filters: {},
  paginationOptions: {}
};
